export default "<div class=\"cover-fill\"\r\n    *ngIf=\"coverUrl\"\r\n    [ngStyle]=\"{'background-image': 'url('+ coverUrl +')'}\">\r\n</div>"